<template>
  <div style="border-top: solid 1px #d8d8d8">
    <div class="d-flex flex-column p-3">

      <div class="d-flex flex-row flex-wrap justify-content-start mb-2">
        <div style="position: relative; z-index: 1">
          <div class="d-flex" style="position: absolute">
            <filtro-descuentos-clientes
              :data="data"
              :dataInicial="dataInicial"
            />
          </div>
        </div>
        <div
          class="d-flex justify-content-center w-100"
          style="margin-top: 110px"
          v-if="loadingTable"
        >
          <Loading />
        </div >
        <div v-else class="w-100 text-center">
          <new-data-table
            customHeaders
            v-if="dataTableAux.length > 0"
            :headers="headers"
            :data="dataTableAux"
            :acciones="actions"
            :max="10"
            :seleccionar="getSelectedRow"
            paginacion
            numerador
            buscar
            idtabla="lista_descuentos_clientes"
          />

          <not-found-table
            v-else
            class="justify-content-center w-100 pt-5"
            :text="'No se encontraron registros de descuentos clientes'"
          />
        </div>
      </div>
    </div>

    <detalle-recargos-tarifas :id="customer_discount_id" :version="1"></detalle-recargos-tarifas>

  </div>
</template>

<script>
// Vue
import Vue from "vue";

// Vuex
import { mapState, mapActions } from "vuex";

// Componentes
import NewDataTable from "../../common/NewDataTable";
import Loading from "../../common/loading";
import FiltroDescuentosClientes from "../../filtros/lineas/tarifas/FiltroDescuentosClientes";
import NotFoundTable from "../../../components/common/NotFoundTable";

// Toast
import VueToastify from "vue-toastify";
import DetalleRecargosTarifas from "@/components/modals/lineas/tarifas/detalle_recargos/DetalleRecargosTarifas.vue";

Vue.use(VueToastify);

export default {
  props: {
    data: { type: Array },
    dataInicial: { type: Array },
    getListaDescuentosClientes: { type: Function, default: () => {} },
  },
  data() {
    return {
      // Estructura para utilizar dataTable vue
      headers: [
        { title: "Cliente", width: "10px" },
        { title: "Naviera", width: "10px" },
        { title: "Naviera Salida", width: "10px" },
        { title: "POL", width: "10px" },
        { title: "POD", width: "10px" },
        { title: "Desde", width: "10px" },
        { title: "Hasta", width: "10px" },
        { title: "Vigencia", width: "10px" },
        { title: "TT", width: "10px" },
        // { title: "Pública + Recargos", width: "10px" },
        // { title: "Neta + Recargos", width: "10px" },
        { title: "Pública (Venta)", width: "10px" },
        { title: "Neta (Costo)", width: "10px" },
        { title: "Descuento", width: "10px" },
        { title: "Contenedor", width: "10px" },
        { title: "Producto", width: "10px" },
        { title: "Atmósfera", width: "10px" },
        { title: "Trat. frío", width: "10px" },
        { title: "D.Libres Origen", width: "10px" },
        { title: "D. Plug Origen", width: "10px" },
        { title: "D. Libres Destino", width: "10px" },
        { title: "D. Plug Destino", width: "10px" },
        { title: "Genset", width: "10px" },
        { title: "Get Out", width: "10px" },
        { title: "Comentarios", width: "10px" },
        { title: "Tipo Contrato", width: "10px" },
        { title: "Nombre Contrato", width: "10px" },
        { title: "Acciones", width: "10px" },
      ],
      actions: [],
      customer_discount_id: 0,
      dataTableAux: this.data,
    };
  },
  components: {
    DetalleRecargosTarifas,
    NewDataTable,
    Loading,
    NotFoundTable,
    FiltroDescuentosClientes,
  },
  computed: {
    ...mapState(["loadingTable"]),
  },
  methods: {

    ...mapActions("lineas", ["actionSetDataListarTarifasDescuentosClientes", "actionsSetShowModalCustomerDiscountsRecharges"]),

    async generateActionsButtons() {

      this.actions = [];

      this.dataTableAux.map((item, index) => {

        this.actions.push([
          {
            icon: "fa fa-dollar-sign",
            title: "Ver Recargos Asociados",
            id: index,
            item
          }
        ]);

      });

    },
    async getSelectedRow(row) {
      
      switch (row.accion) {

        case "Ver Recargos Asociados":

          this.actionsSetShowModalCustomerDiscountsRecharges(true);

          this.customer_discount_id = this.data[row.id].data_complementaria.tariff_client_id;

          break;
      }

    }

  },
  watch: {
    data: function(_new) {

      if (_new) {

        this.dataTableAux = _new;

        this.generateActionsButtons();

      }

    }

  }

};
</script>

<style></style>
